import styled from "styled-components";
import { theme } from "ui";
import { InstallmentContainerProps } from "./installment.types";

export const Container = styled.div<InstallmentContainerProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  max-width: 588px;
  background-color: ${({ isHighlighted }) =>
    isHighlighted ? theme.colors.neutral["white-075"] : "transparent"};
  padding: ${theme.space.x2};
`;

export const InstallmentPrice = styled.p`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["300"]};
  color: ${theme.colors.neutral["550"]};
`;

export const InstallmentTitle = styled(InstallmentPrice)`
  font-weight: ${theme.typography.fontWeight["500"]};
`;

export const SpotTitle = styled.p`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["500"]};
  color: ${theme.colors.neutral["550"]};
`;

export const FeeLegend = styled.span`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["300"]};
  color: ${theme.colors.neutral["550"]};

  @media ${theme.device.mobileFirst.mobileXL} {
    font-weight: ${theme.typography.fontWeight["400"]};
    color: ${theme.colors.neutral["350"]};
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space.x1};
  align-items: flex-start;

  @media ${theme.device.mobileFirst.mobileXL} {
    flex-direction: row;
    gap: ${theme.space.x2};
    align-items: center;
  }
`;
